import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa";

import avatar1 from "../../../assets/avatar1.jpg";
import avatar3 from "../../../assets/avatar1.jpg";
import avatar4 from "../../../assets/avatar1.jpg";
import avatar5 from "../../../assets/avatar1.jpg";
import avatar6 from "../../../assets/avatar1.jpg";
import avatar7 from "../../../assets/avatar1.jpg";
import avatar8 from "../../../assets/avatar1.jpg";
import avatar9 from "../../../assets/avatar1.jpg";
import avatar10 from "../../../assets/avatar1.jpg";
import avatar2 from "../../../assets/avatar2.jpg";
import { useSnack } from "../../../hooks/useSnack";
import studentServices from "../../../services/studentServices";
import Button from "../../Button";
import CustomModal from "../../CustomModal";
import LoadingSpinner from "../../LoadingSpinner";

const SelectStudentAvatarModal = forwardRef(({ onSubmit }, ref) => {
  const { t } = useTranslation();
  const { showSnack } = useSnack();

  const [isOpen, setIsOpen] = useState(false);
  const [avatars, setAvatars] = useState([]);
  const [loading, setLoading] = useState(false);
  const [studentID, setStudentID] = useState(null);
  const [selectedAvatar, setSelectedAvatar] = useState(null);

  useImperativeHandle(ref, () => ({
    openModal(studentID) {
      setStudentID(studentID);
      setSelectedAvatar(null);
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  useEffect(() => {
    if (isOpen) {
      setAvatars([avatar1, avatar2, avatar3, avatar4, avatar5, avatar6, avatar7, avatar8, avatar9, avatar10]);
    }
  }, [isOpen]);

  const handleSelectAvatar = (avatar) => {
    setSelectedAvatar(avatar);
  };

  const handleSave = async () => {
    if (!selectedAvatar) return;
    try {
      setLoading(true);
      await studentServices.updateStudentAvatar(studentID, selectedAvatar);
      if (onSubmit) {
        onSubmit({ studentID, avatar: selectedAvatar });
      }
      setIsOpen(false);
    } catch (error) {
      showSnack(error, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomModal
      isOpen={isOpen}
      withCloseButton={false}
      onClose={() => setIsOpen(false)}
      className="max-w-[55rem] rounded-2xl border-8 border-blue-500 bg-[#F1F1F1] shadow-xl"
      contentClassname="p-6 bg-[#F1F1F1] px-12"
    >
      <div className="flex flex-1 flex-col justify-between gap-6">
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <h3 className="text-center text-xl font-semibold text-blue-500">{t("select_student_avatar")}</h3>

            <div className="custom-scrollbar max-h-[400px] overflow-y-auto p-2">
              <div className="grid grid-cols-3 gap-6 sm:grid-cols-4 md:grid-cols-5">
                {avatars.map((avatar, index) => (
                  <button
                    key={index}
                    onClick={() => handleSelectAvatar(avatar)}
                    className={`relative h-32 w-32 rounded-full transition duration-200 ease-in-out hover:scale-105 focus:outline-none ${
                      selectedAvatar === avatar ? "ring-4 ring-blue-400" : ""
                    }`}
                  >
                    <img
                      src={avatar}
                      alt={`avatar-${index}`}
                      className="h-full w-full rounded-full border border-gray-300 object-cover shadow-sm"
                    />
                    {selectedAvatar === avatar && (
                      <FaCheckCircle
                        className="absolute bottom-1 right-1 rounded-full bg-white text-blue-500"
                        size={20}
                      />
                    )}
                  </button>
                ))}
              </div>
            </div>

            <div className="mt-4 flex justify-end gap-4">
              <Button variant="text" onClick={() => setIsOpen(false)} label={t("cancel")} />
              <Button onClick={handleSave} label={t("save")} disabled={!selectedAvatar} />
            </div>
          </>
        )}
      </div>
    </CustomModal>
  );
});

export default SelectStudentAvatarModal;
